class CountdownTimer {
  constructor(targetDate, elementId) {
    if (!targetDate) {
      console.error('Target date is required');
      return;
    }

    this.targetDate = new Date(targetDate).getTime();
    this.elementId = elementId;
    this.element = document.getElementById(elementId);
    
    if (!this.element) {
      console.error(`Element with id "${elementId}" not found`);
      return;
    }
    if (this.element.dataset.debug === 'true') {
      console.log('Countdown initialized:', {
        targetDate: new Date(targetDate),
        elementId: elementId,
        element: this.element
      });
    }

    this.updateCountdown();
    setInterval(() => this.updateCountdown(), 24 * 60 * 60 * 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));

    if (this.element.dataset.debug === 'true') {
      console.log('Countdown update:', {
        days: days,
        distance: distance,
        now: new Date(now),
        target: new Date(this.targetDate)
      });
    }
    if (days > 0) {
      this.element.innerHTML = `<span class="date">${days}</span> ${days === 1 ? 'Day' : 'Days'}`;
      this.element.classList.remove('ended', 'last-day');
    } else if (days === 0) {
      this.element.innerHTML = `<span class="date">0</span> Days`;
      this.element.classList.add('last-day');
      this.element.classList.remove('ended');
    } else {
      this.element.innerHTML = `<span class="date">0</span> Days`;
      this.element.classList.add('ended');
      this.element.classList.remove('last-day');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM Content Loaded - Initializing countdown timers');
  const countdownElements = document.querySelectorAll('[data-countdown-date]');
  
  console.log('Found countdown elements:', countdownElements.length);
  
  countdownElements.forEach(element => {
    const targetDate = element.getAttribute('data-countdown-date');
    const elementId = element.id;
    
    if (!elementId) {
      console.error('Countdown element must have an id attribute');
      return;
    }
    
    if (!targetDate) {
      console.error('Countdown element must have a data-countdown-date attribute');
      return;
    }
    
    new CountdownTimer(targetDate, elementId);
  });
}); 